<template>
  <div class="form-wrap">
    <label class="checkbox-wrap" :class="{ disabled: disabled }">
      <input
        type="checkbox"
        :id="toKebabCase(name)"
        :name="toKebabCase(name)"
        :disabled="disabled"
        :checked="checked"
        @change="$emit('change', $event.target.checked)"
      />
      {{ label }}
    </label>
  </div>
</template>

<script>
import stringUtils from '@/components/mixins/stringUtils'

export default {
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    checked: { type: Boolean, default: false },
    name: { type: String, required: true },
    label: { type: String, required: true },
    disabled: { type: Boolean, default: false },
  },
  mixins: [stringUtils],
}
</script>

<style lang="scss">
@import './Checkbox.scss';
</style>
